import { DiscountDatesState, DiscountDateRange } from "app/pages/DiscountEditor/modules/DiscountDates/state";
import { DatesFilterDto, DiscountDateRangeDto } from "app/shared/model/DiscountDto";

function getRoot(state: any) : DiscountDatesState {
    return state.discountDates;
}

export function getBookingDateRange(state: any) {
    const root = getRoot(state); 
    return root.bookingDateRange; 
}

export function getProductDateRange(state: any) {
    const root = getRoot(state); 
    return root.productDateRange; 
}

export function getDateFilterDto(state: any) : DatesFilterDto {
    const root = getRoot(state);
    return {
        bookingDateRange: dateRangeToDto(root.bookingDateRange),
        productDateRange: dateRangeToDto(root.productDateRange)
    }
}

function dateRangeToDto(range: DiscountDateRange) : DiscountDateRangeDto {
    const endDate = range.neverExpires 
        ? ''
        : range.to;

    return {
        from: range.from ? range.from : undefined,
        to: endDate ? endDate : undefined
    }
}